<template>
  <AppPopup v-model="open">
    <div class="relative w-96 mt-5">
      <div class="relative w-full h-full px-5 pb-5">
        <Transition
          mode="out-in"
          enter-active-class="transition-all duration-200 ease-in-out"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition-all duration-200 ease-in-out"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <!-- Manual -->
          <div v-if="showManualConnect" class="flex flex-col justify-between items-center">
            <div class="flex flex-col gap-2 items-center justify-center">
              <div
                class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto dark:bg-blue-950 bg-gradient-to-b bg-gradient from-blue-400 to-blue-700 rounded-full sm:mx-0 sm:h-10 sm:w-10"
              >
                <BuildingLibraryIcon class="w-6 h-6 text-white" aria-hidden="true" />
              </div>
              <div class="font-semibold text-lg text-gray-900 mb-10">Link External Account</div>
            </div>
            <form class="flex flex-col flex-wrap gap-5 min-w-80">
              <AppInput
                id="account_nickname"
                ref="safe_account_nickname"
                v-model="external_account.account_nickname"
                label="Account Nickname"
                placeholder="ex. Jimmy's Savings"
                tooltip="This is only for you, choose something that you will recognize and remember"
              />
              <AppInput
                id="account_holder_fullname"
                ref="safe_account_holder_fullname"
                v-model="external_account.account_holder_fullname"
                label="Account Holder's Full Name"
                placeholder="ex. Jonathon Brian Smith"
              />
              <AppInput
                id="bank_name"
                ref="safe_bank_name"
                v-model="external_account.bank_name"
                label="Bank Name"
                placeholder="ex. Bank of America"
              />
              <div class="flex gap-5">
                <AppInput
                  id="routing_number"
                  ref="safe_routing_number"
                  v-model="external_account.routing_number"
                  label="Routing Number"
                  placeholder="ex. 123456789"
                />
                <AppInput
                  id="account_number"
                  ref="safe_account_number"
                  v-model="external_account.account_number"
                  label="Account Number"
                  placeholder="ex. 987654321"
                />
              </div>
            </form>

            <div class="flex justify-between gap-5 mt-12 w-full">
              <AppButtonSecondary text="Back" :icon="ChevronLeftIcon" :icon-first="true" size="lg" class="w-fit" @click="showManualConnect = false" />
              <AppButtonPrimary text="Connect Account" size="lg" :icon="LinkIcon" class="w-fit" :loading="connecting_external_account" @click="createExternalAccount()" />
            </div>
          </div>
          <!-- Plaid -->
          <div v-else-if="showPlaidConnect" class="flex flex-col min-h-[500px] justify-between items-center">
            <div class="flex flex-col items-center justify-center h-full mt-20">
              <svg xmlns="http://www.w3.org/2000/svg" height="100" viewBox="-18.89985 -11.86825 163.7987 71.2095" class="-m-2">
                <path
                  d="M66.248 16.268c-1.057-.889-2.861-1.333-5.413-1.333h-5.756v17.788h4.304v-5.575h1.928c2.34 0 4.056-.515 5.148-1.546 1.23-1.155 1.849-2.693 1.849-4.613 0-1.991-.687-3.565-2.06-4.721m-5.044 6.855h-1.821V18.96h1.636c1.99 0 2.985.698 2.985 2.094 0 1.378-.934 2.068-2.8 2.068m14.469-8.188h-4.488v17.788h9.69v-4.026h-5.202zm13.995 0l-7.05 17.788h4.832l.924-2.586H94.5l.845 2.586h4.886l-7-17.788zm-.053 11.601l1.849-6.08 1.82 6.08h-3.67zm12.858 6.187h4.489V14.934h-4.489zm21.917-14.454a7.376 7.376 0 00-2.14-2.053c-1.355-.854-3.204-1.28-5.545-1.28h-5.914v17.787h6.918c2.5 0 4.506-.817 6.02-2.453 1.514-1.635 2.27-3.805 2.27-6.508 0-2.15-.537-3.981-1.61-5.493m-7.182 10.427h-1.927v-9.734h1.954c1.373 0 2.428.43 3.168 1.287.74.857 1.11 2.073 1.11 3.647 0 3.2-1.435 4.8-4.305 4.8M18.637 0L4.09 3.81.081 18.439l5.014 5.148L0 28.65l3.773 14.693 14.484 4.047 5.096-5.064 5.014 5.147 14.547-3.81 4.008-14.63-5.013-5.146 5.095-5.063L43.231 4.13 28.745.083l-5.094 5.063zM9.71 6.624l7.663-2.008 3.351 3.44-4.887 4.856zm16.822 1.478l3.405-3.383 7.63 2.132-6.227 6.187zm-21.86 9.136l2.111-7.705 6.125 6.288-4.886 4.856-3.35-3.44zm29.547-1.243l6.227-6.189 1.986 7.74-3.404 3.384zm-15.502-.127l4.887-4.856 4.807 4.936-4.886 4.856zm-7.814 7.765l4.886-4.856 4.81 4.936-4.888 4.856zm15.503.127l4.886-4.856L36.1 23.84l-4.887 4.856zM4.57 29.927l3.406-3.385 4.807 4.937-6.225 6.186zm14.021 1.598l4.887-4.856 4.808 4.936-4.886 4.856zm15.502.128l4.887-4.856 3.351 3.439-2.11 7.705zm-24.656 8.97l6.226-6.189 4.81 4.936-3.406 3.385-7.63-2.133zm16.843-1.206l4.886-4.856 6.126 6.289-7.662 2.007z"
                  fill-rule="evenodd"
                  fill="#000000"
                />
              </svg>
              <div class="w-32 h-32 mt-3">
                <SpinnerJump />
              </div>
            </div>
            <TransitionRoot as="template" :show="showPlaidConnect">
              <Dialog class="relative z-[99999]" @close="showPlaidConnect = false">
                <TransitionChild
                  as="template"
                  enter="ease-out duration-300"
                  enter-from="opacity-0"
                  enter-to="opacity-100"
                  leave="ease-in duration-200"
                  leave-from="opacity-100"
                  leave-to="opacity-0"
                >
                  <div class="fixed inset-0 bg-gray-500/75 transition-opacity" />
                </TransitionChild>

                <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                  <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild
                      as="template"
                      enter="ease-out duration-300"
                      enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      enter-to="opacity-100 translate-y-0 sm:scale-100"
                      leave="ease-in duration-200"
                      leave-from="opacity-100 translate-y-0 sm:scale-100"
                      leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                      <DialogPanel>
                        <div v-if="showPlaidConnect">
                          <iframe :src="url" class="absolute inset-0 w-screen h-screen" frameBorder="0"></iframe>
                        </div>
                      </DialogPanel>
                    </TransitionChild>
                  </div>
                </div>
              </Dialog>
            </TransitionRoot>
          </div>
          <!-- Connect Existing Account -->
          <div v-else-if="!show_new_connection_view" class="flex flex-col items-center">
            <div class="h-fit mt-5 overflow-visible w-full">
              <div class="flex flex-col gap-2 items-center justify-center">
                <div
                  class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto dark:bg-blue-950 bg-gradient-to-b bg-gradient from-blue-400 to-blue-700 rounded-full sm:mx-0 sm:h-10 sm:w-10"
                >
                  <ArrowUturnDownIcon class="w-6 h-6 text-white" aria-hidden="true" />
                </div>
                <div class="font-semibold text-lg text-gray-900 mb-2">Find an External Account</div>
              </div>
              <div v-if="external_accounts.length > 0" class="flex flex-col items-center my-10 min-w-full gap-5">
                <div class="w-full flex flex-col items-center">
                  <div class="text-gray-500 text-sm self-start mb-2">Connect quickly using one of your saved external account?</div>
                  <AppSelect
                    v-model="existing_external_account"
                    label="Choose an external account"
                    :items="external_accounts"
                    :inverted="true"
                    type="accounts-with-ids"
                    class="w-full"
                  />
                </div>
              </div>
              <div v-else class="my-10">You do not have any existing accounts</div>

              <div class="flex justify-between gap-5 w-full mt-12">
                <AppButtonSecondary
                  text="Back"
                  :icon="ChevronLeftIcon"
                  :icon-first="true"
                  size="lg"
                  class="w-fit"
                  @click="show_new_connection_view = true"
                />
                <AppButtonPrimary
                  v-if="external_accounts.length > 0"
                  text="Connect external account"
                  size="lg"
                  :icon="CloudArrowUpIcon"
                  :loading="existing_external_account_loading"
                  class="w-fit"
                  @click="connectFromExistingExternalAccount()"
                />
              </div>
            </div>
          </div>
          <!-- Options -->
          <div v-else class="flex flex-col items-center gap-5">
            <div class="w-52 -mt-8">
              <Vue3Lottie
                animation-link="https://lottie.host/03fb90e1-fc29-451b-b766-ced59d5017b8/ZaOaaJa2e6.json"
                :height="200"
                :width="200"
                :loop="false"
                :auto-play="true"
              />
            </div>

            <div class="flex flex-col gap-4 items-center -mt-8">
              <div v-if="custody_accounts.length > 0">
                <div class="text-gray-500 text-sm mb-2">Keep in mind each account can only have one external account linked at a time.</div>
                <AppSelect v-model="internal_account" label="Choose an account" :items="custody_accounts" type="accounts-with-ids" class="w-full" />
              </div>
            </div>

            <div class="text-gray-600 text-center max-w-80 mt-2">Connect your bank easily with Plaid. This is the fastest and most secure way.</div>
            <AppButtonPrimary text="Connect with Plaid" size="xl" color="purple" :icon="LockClosedIcon" class="w-fit" @click="getPlaidUrl()" />
            <div class="flex items-center mt-1">
              <div class="w-32 border-t border-gray-300"></div>
              <span class="px-3 text-gray-600">Or</span>
              <div class="w-32 border-t border-gray-300"></div>
            </div>
            <div class="text-gray-600 text-center max-w-80">Connect directly by entering your account details. This method works with any bank.</div>
            <AppButtonPrimary text="Connect Manually" size="xl" :icon="BuildingLibraryIcon" class="w-fit" @click="showManualConnect = true" />

            <div v-if="external_accounts.length > 0" class="flex flex-col items-center gap-5">
              <div class="flex items-center mt-1">
                <div class="w-32 border-t border-gray-300"></div>
                <span class="px-3 text-gray-600">Or</span>
                <div class="w-32 border-t border-gray-300"></div>
              </div>
              <AppButtonSecondary
                v-if="external_accounts.length > 0"
                text="Use an existing external account"
                size="xl"
                class="w-fit"
                :icon="ArrowUturnLeftIcon"
                @click="show_new_connection_view = false"
              />
            </div>
          </div>
        </Transition>
      </div>
    </div>
  </AppPopup>
</template>

<script setup>
// Essentials
import { ref, watch, onMounted, onUnmounted } from "vue";

import { TransitionChild, TransitionRoot, Dialog, DialogPanel } from "@headlessui/vue";

// Components
import AppPopup from "@/components/applicationui/AppPopup.vue";
import AppButtonPrimary from "@/components/applicationui/AppButtonPrimary.vue";
import AppButtonSecondary from "@/components/applicationui/AppButtonSecondary.vue";
import AppInput from "@/components/applicationinputs/AppInput.vue";
import AppSelect from "@/components/applicationinputs/AppSelect.vue";
import SpinnerJump from "@/components/loading/SpinnerJump.vue";

// Icons
import { Vue3Lottie } from "vue3-lottie";
import {
  BuildingLibraryIcon,
  LockClosedIcon,
  ChevronLeftIcon,
  LinkIcon,
  CloudArrowUpIcon,
  ArrowUturnLeftIcon,
  ArrowUturnDownIcon,
} from "@heroicons/vue/24/outline";

// Stores
import { useAccountsStore } from "@/stores/accounts";
const accountsStore = useAccountsStore();

// Model
const open = defineModel({
  type: Boolean,
  required: true,
});

// Props
const props = defineProps({
  account: {
    type: Object,
    required: false,
    default: null,
  },
});

// Emits
const emit = defineEmits(["error", "success"]);

// Manually Connect Bank START
import { ExternalAccountSchema } from "@/schemas/ExternalAccountSchema.ts";
const existing_external_account = ref(null);
const showManualConnect = ref(false);
const connecting_external_account = ref(false);
const external_account = ref({
  account_nickname: "",
  account_holder_fullname: "",
  bank_name: "",
  routing_number: "",
  account_number: "",
  types: "Account",
  accountType: "checking",
});

async function createExternalAccount() {
  connecting_external_account.value = true;
  // Validate the schema
  const { data: stripped_external_account, error } = ExternalAccountSchema.safeParse(external_account.value);
  if (error) {
    await showInvalidFields(error.errors);
    connecting_external_account.value = false;
    return;
  }

  // capitalize the account type "checking" => "Checking"
  stripped_external_account.accountType =
    stripped_external_account.accountType.charAt(0).toUpperCase() + stripped_external_account.accountType.slice(1);

  // Connect the external account
  let data = await accountsStore.connectExternalAccount(internal_account.value.id, internal_account.value.tapi_account_id, internal_account.value.has_linked_external_account, stripped_external_account);

  // Check if the data is null
  if (!data) {
    connecting_external_account.value = false;
    showManualConnect.value = false;
    emit("error");
    return;
  }

  // Close the popup
  connecting_external_account.value = false;
  open.value = false;
  showManualConnect.value = false;

  // Emit the success
  emit("success");
}

const safe_account_nickname = ref(null);
const safe_account_holder_fullname = ref(null);
const safe_bank_name = ref(null);
const safe_routing_number = ref(null);
const safe_account_number = ref(null);

const refs = {
  safe_account_nickname,
  safe_account_holder_fullname,
  safe_bank_name,
  safe_routing_number,
  safe_account_number,
};
const getRef = (name) => {
  return refs[name];
};
const showInvalidFields = async (errors) => {
  let first_ref = null;
  for (const error of errors) {
    //This needs to be a for loop so we can use async/await
    const invalid_input_ref = getRef(`safe_${error.path[0]}`);
    const invalid_switch_ref = getRef(`safe_switch_${error.path[0]}`);
    const invalid_select_ref = getRef(`safe_select_${error.path[0]}`);

    if (invalid_input_ref?.value) {
      invalid_input_ref.value?.setErrorMessage(error.message);
      if (!first_ref) first_ref = invalid_input_ref.value;
      break;
    } else if (invalid_switch_ref?.value) {
      invalid_switch_ref.value.showError(error.message);
      if (!first_ref) first_ref = invalid_switch_ref.value;
      break;
    } else if (invalid_select_ref?.value) {
      invalid_select_ref.value.showError(error.message);
      if (!first_ref) first_ref = invalid_select_ref.value;
      break;
    }
  }
  // Scroll to the last invalid input
  if (first_ref) first_ref.$el.scrollIntoView({ block: "center", inline: "nearest" });
  else window.scrollTo({ top: 0, behavior: "smooth" });
  return;
};
// Manually Connect Bank END

// Connect with Plaid START
const url = ref("");
const showPlaidConnect = ref(false);
async function getPlaidUrl() {
  showPlaidConnect.value = true;

  // Decide if we are updating or creating, then get the Plaid URL
  let data = null;
  if (internal_account.value.has_linked_external_account) {
    data = await accountsStore.updatePlaid(internal_account.value.id, internal_account.value.tapi_account_id);
  } else {
    data = await accountsStore.getPlaid(internal_account.value.id, internal_account.value.tapi_account_id);
  }

  // Check if the data is null
  if (!data) {
    showPlaidConnect.value = false;
    emit("error");
    return;
  }

  // Set the URL
  url.value = data.accountDetails;

  // Listen for the event message
  window.addEventListener("message", handlePlaidMessage);
}

async function handlePlaidMessage(event) {
  if (!event.origin.includes("norcapsecurities.com")) return;
  if (!event) return;
  if (!event.data) return;
  if (!event.type) return;
  if (event.type != "message") return;
  if (typeof event.data != "string") return;
  if (event.data === "signing_complete") return; // (This is needed since I never remove this event listener in some cases)
  let response = JSON.parse(event.data);
  if (response.statusCode === 101 || response.statusCode === "101") {
    accountsStore.createExternalAccountSupaabse(internal_account.value.id, response.plaidAccountDetails[0].account_name);
    // Handle success and failure
    open.value = false;
    showPlaidConnect.value = false;
    emit("success");
  }
}
// Connect with Plaid End

// Connect from existing external account START
const show_new_connection_view = ref(true);
const existing_external_account_loading = ref(false);
async function connectFromExistingExternalAccount() {
  existing_external_account_loading.value = true;
  // Get the external account info from the selected external account id
  let response = await accountsStore.getExternalAccount(existing_external_account.value.id, existing_external_account.value.tapi_account_id);

  if (!response) {
    existing_external_account_loading.value = false;
    open.value = false;
    show_new_connection_view.value = true;
    emit("error");
    return;
  }

  // Add bank name to response
  let bank_name = response.statusDesc.bankName
  if (!bank_name) { bank_name = response.statusDesc.AccountName; }

  const ext_account = {
    account_nickname: existing_external_account.value.external_account_nickname,
    account_holder_fullname: `${existing_external_account.value.parties.first_name} ${existing_external_account.value.parties.last_name}`,
    bank_name,
    routing_number: response.statusDesc.AccountRoutingNumber,
    account_number: response.statusDesc.AccountNumber,
    types: "Account",
    accountType: "checking",
  };

  // Connect the external account
  let data = await accountsStore.connectExternalAccount(internal_account.value.id, internal_account.value.tapi_account_id, internal_account.value.has_linked_external_account, ext_account);

  // Check if the data is null
  if (!data) {
    existing_external_account_loading.value = false;
    open.value = false;
    show_new_connection_view.value = true;
    emit("error");
    return;
  }

  // Handle Success
  existing_external_account_loading.value = false;
  open.value = false;
  show_new_connection_view.value = true;
  emit("success");
}

// Connect from existing external account END

// Set custody accounts START
const custody_accounts = ref([]);
const setCustodyAccounts = async () => {
  custody_accounts.value = await accountsStore.getCustodyAccounts();
};
// Set custody accounts END

// Set external accounts START
const external_accounts = ref([]);
const setExternalAccounts = async () => {
  await accountsStore.setMyAccounts();

  accountsStore.myAccounts.forEach((account) => {
    if (account.has_linked_external_account) {
      // eslint-disable-next-line no-unused-vars
      const { name, ...rest } = account;
      external_accounts.value.push({
        name: account.external_account_nickname,
        ...rest,
      });
    }
  });

  if (external_accounts.value.length > 0) {
    existing_external_account.value = external_accounts.value[0];
  }
};
// Set external accounts END

// Selected Internal Account START
const internal_account = ref(null);
const setDefaultInternalAccount = () => {
  if (props.account) {
    const found_internal_account = custody_accounts.value.find((account) => account.id === props.account.id);
    if (found_internal_account) {
      internal_account.value = found_internal_account;
    } else {
      internal_account.value = custody_accounts.value[0];
    }
  } else if (custody_accounts.value.length > 0) {
    internal_account.value = custody_accounts.value[0];
  } else {
    internal_account.value = accountsStore.holdingAccount;
  }
};
// Selected Internal Account END

// Mounted
onMounted(async () => {
  if (!accountsStore.holdingAccount) {
    open.value = false;
    return;
  }

  // Get all accounts
  await setCustodyAccounts();

  // get all external accounts
  await setExternalAccounts();

  // Set default internal account
  setDefaultInternalAccount();
});

// Unmounted
onUnmounted(() => {
  window.removeEventListener("message", handlePlaidMessage);
});

// Watchers (I know this looks weird, but it works)
watch(
  () => props.account,
  () => {
    setDefaultInternalAccount();
  },
);
</script>
